import React, { useEffect, useState } from "react";
import styles from "../PreviewV3.module.css";

const READINESS_SECTIONS = [
  { label: "Readiness Details", targetId: "emergency-readiness-sec-details" },
  { label: "Checklist Questions", targetId: "emergency-readiness-sec-questions" },
  {
    label: "Flagged Non-Conformances & Corrective Actions",
    targetId: "emergency-readiness-sec-flagged"
  },
  { label: "Readiness Sign Off", targetId: "emergency-readiness-sec-signoff" }
];

export default function EmergencyReadinessPreviewNav({ readinessNumber }) {
  const firstSectionTargetId = READINESS_SECTIONS[0].targetId;
  const [activeSectionTargetId, setActiveSectionTargetId] = useState(firstSectionTargetId);

  useEffect(() => {
    setActiveSectionTargetId(firstSectionTargetId);
  }, [firstSectionTargetId]);

  return (
    <aside className={styles.PreviewNav}>
      <div className={styles.PreviewNavCard}>
        <div className={styles.PreviewNavHead}><h3>Document Sections</h3></div>
        {readinessNumber ? (
          <div className={styles.PreviewNavDocumentNumber}>{readinessNumber}</div>
        ) : null}
        <div className={styles.PreviewNavList} id="emergency-readiness-prv-nav-list">
          {READINESS_SECTIONS.map((section, index) => {
            const isActive = activeSectionTargetId === section.targetId;

            const handleClick = (event) => {
              event.preventDefault();
              setActiveSectionTargetId(section.targetId);

              const targetElement = document.getElementById(section.targetId);
              if (targetElement) {
                targetElement.scrollIntoView({ behavior: "smooth", block: "start" });
              }
            };

            return (
              <a
                key={section.targetId}
                className={`${styles.PreviewNavItem} ${isActive ? styles.PreviewNavActiveItem : ""}`}
                data-target={section.targetId}
                onClick={handleClick}
              >
                <span className={styles.PreviewNavNum}>{index + 1}</span> {section.label}
              </a>
            );
          })}
        </div>
      </div>
    </aside>
  );
}
